// extracted by mini-css-extract-plugin
export default {"saveButton":"app-portainer-settings-edge-compute-SettingsEdgeCompute-SettingsEdgeCompute-module__save-button"};